import {
  CenteredFadeInSpinner,
  CenteredMessage,
  FeatureFlagsContext,
} from '@tableau/data-catalog-shared';
import * as React from 'react';
import { Query } from 'react-apollo';

import { Messages } from '../../../gen-src/Localize';
import { DatabaseQuery, DatabaseQuery_databases, DatabaseQueryVariables } from '../../../gen-src/queries/DatabaseQuery';
import { DatabaseQueryGql } from '../../queries/DatabaseQueryGql';
import { renderQueryResult } from '../renderQueryResult';
import { createRenderDataWithErrorFunction, renderError, renderNoData } from '../widgets/ErrorMessageWidgets';

export type DatabaseQueryWrapperProps = {
  readonly databaseId: string;
  readonly children: (result: DatabaseQuery_databases) => React.ReactNode;
};

export const DatabaseQueryWrapper = (props: DatabaseQueryWrapperProps) =>  {
    const { publishedConnectionsLineageEnabled } = React.useContext(FeatureFlagsContext);

    const renderDatabaseData = React.useCallback(
      (data: DatabaseQuery): Readonly<React.ReactNode> => {
        const database = data.databases ? data.databases[0] : null;
        if (database) {
          return props.children(database);
        } else {
          return <CenteredMessage message={Messages.ErrorItemNotFound()} />;
        }
      },
      [props]
    );

    return (
      <Query<DatabaseQuery, DatabaseQueryVariables>
        query={DatabaseQueryGql}
        variables={{
          databaseId: props.databaseId,
          publishedConnectionsLineageEnabled
        }}
      >
        {result => renderQueryResult(result, {
          renderLoading: () => <CenteredFadeInSpinner />,
          renderData: renderDatabaseData,
          renderNoData: renderNoData,
          renderDataWithError: createRenderDataWithErrorFunction(renderDatabaseData),
          renderError: renderError,
        })}
      </Query>

    );



}
